export const API_BASE = import.meta.env['VITE_API_BASE'] || '/api';
export const IS_DEV = import.meta.env.DEV;
